import React, { useEffect } from 'react';

const ContactModal = ({ isOpen, onClose, title, children }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="modal is-active"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <div
        className="modal-background"
        onClick={onClose}
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }} // Semi-transparent background
      ></div>
      <div
        className="modal-content"
        style={{
          maxWidth: '640px',
          margin: '0 auto',
          borderRadius: '4px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
          position: 'relative',
        }}
      >
        <div className="box" style={{ padding: '20px' }}>
          <h2
            className="modal-title"
            style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              marginBottom: '20px',
              color: '#333',
              textAlign: 'center',
            }}
          >
            {title}
          </h2>
          <footer style={{
            textAlign: 'center',
            fontSize: '0.8rem',
            color: '#666',
          }}>Click anywhere or hit <i>Esc</i> to close modal</footer>
          <hr />
          {children}
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
